import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Contributor from './contributor';
import useContributorStore from './state-hook';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > div:first-child {
    border-bottom: 1px solid #d7dfe7;
  }

  & > a {
    margin-top: 8px;
    margin-right: 3px;
    align-self: flex-end;
    text-transform: uppercase;
    color: ${props => props.theme.primaryColor};
    font: ${props => props.theme.fontWeightDccc} 12px/14px ${props => props.theme.fontFamilyBody};

    :hover {
      text-decoration: none;
    }
  }
`;

export default function View(props) {
  const set = useContributorStore(state => state.set);
  const dft = useContributorStore(state => state.dft);

  const change = e => {
    e && e.preventDefault();
    set(state => {
      state.toChange = true;
    });
  };

  return (
    <Wrapper>
      <Contributor {...props} isDefault={dft === props.slug} />
      <a href="#" onClick={change}>change</a>
    </Wrapper>
  );
}

View.propTypes = {
  slug: PropTypes.string.isRequired,
};
